import React from 'react';
import { BALANCE, CREDIT, DEPOSIT, DEPOSIT1, DEPOSIT2, FULL } from '../consts/paymentTypes';
import { formatRoundedDownPrice } from "../helpers/formatPrice";

const PaymentBar = ({ 
  payments, 
  totalValue, 
  paymentBarMilestones, 
  paymentBarPercentages,
  testId 
}) => {
  const getPaidAmount = (type) => {
    const amount = Number(payments.find(p => p.type === type)?.amount)
    return amount;
  }

  const depositPaidInOnePayment = !!getPaidAmount(DEPOSIT);
  const hasPaidDeposit1 = !!getPaidAmount(DEPOSIT1);
  const hasPaidDeposit2 = !!getPaidAmount(DEPOSIT2);
  const hasFullPaid = !!getPaidAmount(FULL);

  const generateMilestones = () => {
    const milestones = [];
    if (paymentBarPercentages?.deposit) {
      milestones.push({ 
        name: 'Deposit', 
        percentage: paymentBarPercentages?.deposit, 
        amount: Number(paymentBarMilestones[DEPOSIT]) || 0,
        paidAmount: (getPaidAmount(DEPOSIT1) + getPaidAmount(DEPOSIT2)) || getPaidAmount(DEPOSIT) || 0 
      })
    }
    if (paymentBarPercentages?.balance) {
      milestones.push({ 
        name: 'Balance', 
        percentage: paymentBarPercentages?.balance, 
        amount: paymentBarMilestones[BALANCE] || 0,
        paidAmount: getPaidAmount(BALANCE) || 0 
      })
    }
    if (paymentBarPercentages?.credit) {
      milestones.push({ 
        name: 'Credit', 
        percentage: paymentBarPercentages?.credit, 
        amount: paymentBarMilestones[CREDIT] || 0,
        paidAmount: getPaidAmount(CREDIT) || 0 
      })
    }
    return milestones;
  }
  const milestones = generateMilestones();

  // Helper function to format numbers with commas and no decimal places
  const formatNumber = (num) => {
    return Math.round(num).toLocaleString('en-US');
  };

  const PAID_BG = '#DCFCE6';
  const PAID_FG = '#166534';
  const MUTED_BG = '#EFEFEF';

  return (
    <div className="w-full" data-testid={testId}>
      <div className="flex gap-1">
        {milestones.map((milestone, index) => {
          const styles = {};
          if (hasFullPaid) {
            styles.background = PAID_BG;
            styles.color = PAID_FG;
          } else if (milestone.name === 'Deposit') {
            const fullyPaid = depositPaidInOnePayment || (hasPaidDeposit1 && hasPaidDeposit2);
            styles.background = fullyPaid
              ? PAID_BG
              : hasPaidDeposit1 || hasPaidDeposit2
                ? `linear-gradient(to right, ${PAID_BG} 50%, ${MUTED_BG} 50%)`
                : MUTED_BG;
            styles.color = fullyPaid ? PAID_FG : '#111827';
          } else {
            styles.background = milestone.paidAmount ? PAID_BG : MUTED_BG;
            styles.color = milestone.paidAmount ? PAID_FG : '#111827';
          }

          return (
            <div key={milestone.name} className="flex-1 min-w-0">
              <div
                data-testid={testId ? `${testId}_milestone_${index}` : undefined}
                style={styles}
                className="h-8 rounded-md flex items-center justify-center text-[13px] font-semibold tabular-nums overflow-hidden"
                title={`$${formatNumber(milestone.amount)}`}
              >
                ${formatNumber(milestone.amount)}
              </div>
              <div className="mt-1 text-center text-xs text-gray-500">{milestone.name}</div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default PaymentBar;